import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { GlobalMessageService } from '@spartacus/core';
import {
  ProductListComponent,
  ProductListComponentService,
  PageLayoutService,
  ViewConfig,
  ICON_TYPE,
} from '@spartacus/storefront';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-has-service-solution-tab',
  templateUrl: './has-service-solution-tab.component.html',
  styleUrls: ['./has-service-solution-tab.component.scss'],
  standalone: false
})
export class HasServiceSolutionTabComponent extends ProductListComponent {
  @Input() product;
  productCopy: any;
  isMobile: boolean;
  showSearch: boolean[] = [false];
  showToggleResults: boolean[] = [];
  customViewMode: any[] = ['List'];
  customViewModeIAMP: string = 'List';
  showIampSearch = false;
  showIampToggleResults: any = true;
  inputFormControl = new FormControl('');
  sortControl = new FormControl('code_asc');
  filteredProduct: any;
  initialKbEcomDocuments: any;
  test: any;
  currentArray: any;
  sortedArray: any;
  initialCounter: number = 0;
  isIampProduct: any;
  iampProductCopy: any;
  sortedResult: any;
  SearchedResult: any;
  iconTypes = ICON_TYPE;

  private destroy$ = new Subject<void>();
  constructor(
    public breakpointObserver: BreakpointObserver,
    productListComponentService: ProductListComponentService,
    pageLayoutService: PageLayoutService,
    globalMessageService: GlobalMessageService,
    scrollConfig: ViewConfig,
    private cdr: ChangeDetectorRef
  ) {
    super(
      pageLayoutService,
      productListComponentService,
      globalMessageService,
      scrollConfig
    );


    this.breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        this.isMobile = result.matches;

      });
  }

  CusTomchangeModeIAMP() {
    this.customViewModeIAMP = this.customViewModeIAMP === 'Grid' ? 'List' : 'Grid';
    this.cdr.detectChanges();
  }
  CusTomchangeMode(index) {
    this.customViewMode[index] = this.customViewMode[index] === 'Grid' ? 'List' : 'Grid';
    this.cdr.detectChanges();
  }
  InputValueChanged(el, isIampProduct, ArrayName?) {
    const newValue = (el.target as HTMLSelectElement).value;
    if (isIampProduct) {
      this.iammPsearch(newValue, ArrayName);
    }
    else {
      this.search(newValue, ArrayName);
    }
  }
  sortControlValueChanged(el, isIampProduct, ArrayName?) {
    const newValue = (el.target as HTMLSelectElement).value;
    if (isIampProduct) {
      this.iammPsortBy(newValue, ArrayName);
    }
    else {
      this.sortBy(newValue, ArrayName);
    }
  }

  sortBy(option: string, ArrayName?) {
    const key = ArrayName;

    this.sortedArray = this.product.hasServiceSolution[ArrayName].slice();

    const [property, order] = option.split('_');
    this.productCopy[key] = this.sortedArray.sort((a, b) => {
      const aValue = a.target[property] || a[property];
      const bValue = b.target[property] || b[property];
      if (aValue < bValue) {
        return order === 'asc' ? -1 : 1;
      } else if (aValue > bValue) {
        return order === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  search(value: string, ArrayName?: string) {
    this.currentArray = this.product.hasServiceSolution[ArrayName];
    if (value.trim() === '') {
      this.productCopy[ArrayName] = this.currentArray;
    } else {
      // Perform filtering based on search term
      this.productCopy[ArrayName] = this.currentArray.filter((item) => {
        return Object.values(item.target || item).some((val: any) =>
          val.toString().toLowerCase().includes(value.toLowerCase())
        );
      });
    }
  }

  iammPsearch(value: string, ArrayName?: string) {
    this.currentArray = this.product.iamppProducts;
    if (value.trim() === '') {
      this.iampProductCopy = this.currentArray;
    } else {
      this.iampProductCopy = this.currentArray.filter((item) => {
        return Object.values(item.target || item).some((val: any) =>
          val.toString().toLowerCase().includes(value.toLowerCase())
        );
      });
    }
  }

  iammPsortBy(option: string, ArrayName?) {
    const key = ArrayName;
    this.sortedArray = this.product.iamppProducts.slice();
    const [property, order] = option.split('_');
    this.iampProductCopy = this.sortedArray.sort((a, b) => {
      const aValue = a.target[property] || a[property];
      const bValue = b.target[property] || b[property];
      if (aValue < bValue) {
        return order === 'asc' ? -1 : 1;
      } else if (aValue > bValue) {
        return order === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }

  getObjectKeys(obj: any) {
    return Object.keys(obj);
  }
  isArray(value: any, index) {
    if (Array.isArray(value) && value.length > 0 && this.initialCounter == 0) {
      if (this.product?.iamppProducts) {
        if (this.product?.iamppProducts.length == 0) {
          this.showToggleResults[index] = true; //show toggle only if iammp is not there.
        }
      }
      else {
        this.showToggleResults[index] = true;
      }
      this.initialCounter = 1;
    }
    return Array.isArray(value);
  }
  ngOnChanges() {

    this.productCopy = JSON.parse(
      JSON.stringify(this.product.hasServiceSolution)
    );
    if (this.product?.iamppProducts) {
      this.iampProductCopy = JSON.parse(
        JSON.stringify(this.product?.iamppProducts)
      );
    }
  }
  override ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
